@if (tabs.length > 0) {
    <section class="horses-race-details greyhound-box">
        @if (!isMobile) {
            <div class="greyhound-race-info">
                <div class="breadcrumb-back" (click)="goBack()">
                    <span class="breadcrumb-theme-left"><i class="theme-left"></i></span>
                    <div class="location-name">
                        <strong> {{ meetingName }} </strong>
                    </div>
                </div>
                <div class="header-right">
                    <ds-tabs-group
                        fullWidthTabs="false"
                        size="small"
                        variant="horizontal"
                        scrollSpeed="fast"
                        class="icon-alignment arrow-alignment"
                        [scrollable]="true"
                        [activeTab]="active.id.toString()"
                        (activeTabChange)="selected($event)">
                        @for (tab of tabs; track tab.id) {
                            <ds-tab [name]="tab.id.toString()">
                                <ng-container *dsTabHeader>
                                    <a [msLink]="tab.url" [vnSpeculativeLink]="tab.url ?? ''">
                                        @if (tab.icon) {
                                            <vn-icon class="race-resulted-icon" size="15" [name]="tab.icon" />
                                        }
                                        {{ tab.title }}
                                    </a>
                                </ng-container>
                            </ds-tab>
                        }
                    </ds-tabs-group>
                </div>
            </div>
        }
    </section>
}
@if (races.length) {
    <section class="horses-meeting-all">
        <div class="content-wrapper">
            @for (race of races; track race.fixture.id) {
                <ms-list-item
                    msTrackReferringActionDirective
                    [trackingValue]="trackingValue()"
                    [cleanAfterTrack]="cleanedAfterTrack()"
                    [title]="(race.startDate | date: 'H:mm') + ' ' + (race.fixture.addons.distance || '')"
                    [boldTitle]="false"
                    [href]="race.fixtureUrl"
                    [isShowBorder]="!$last"
                    [showStartSlot]="shouldShowStartSlot(race)"
                    (itemClicked)="onFixtureClick(race.fixture)">
                    @if (race.pricingState === pricingStates.Resulted) {
                        <span item-icon>
                            <vn-icon
                                name="sports-race-resulted"
                                class="greyhounds-pirced-resulted-all resulted-all race-resulted-icon"
                                width="11"
                                height="12" />
                        </span>
                    }
                    @if (race.pricingState === pricingStates.Priced) {
                        <span item-icon>
                            <vn-icon name="sports-priced" class="icon-sports-priced greyhounds-pirced-resulted-all" width="14" height="12" />
                        </span>
                    }
                    @if (race.pricingState === pricingStates.RaceOff) {
                        <span item-icon>
                            <vn-icon name="sports-greyhounds-race-off" class="greyhounds-race-off-all" width="14" height="12" />
                        </span>
                    }
                    <span badge>
                        <div class="badges-wrapper">
                            <ms-race-view-best-odds-badge [fixture]="race.fixture" />
                        </div>
                    </span>
                </ms-list-item>
            }
        </div>
    </section>
} @else {
    <ms-error severity="info" [message]="sitecore.event.ErrNoEventsPerFilter" />
}
